/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Solver_EndInputs */

const en_cp_solver_end = /** @type {(inputs: Cp_Solver_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handover to the problem owner. The export package (wiki + PRD + evidence log) becomes the report appendix.`)
};

const id_cp_solver_end = /** @type {(inputs: Cp_Solver_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serah terima ke pemilik masalah. Paket ekspor (wiki + PRD + log bukti) jadi lampiran laporan.`)
};

/**
* | output |
* | --- |
* | "Handover to the problem owner. The export package (wiki + PRD + evidence log) becomes the report appendix." |
*
* @param {Cp_Solver_EndInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_solver_end = /** @type {((inputs?: Cp_Solver_EndInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Solver_EndInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_solver_end(inputs)
	return en_cp_solver_end(inputs)
});